module.exports = __webpack_public_path__ + "img/54.c621b2b8.jpg";